"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var useTranslation_1 = __importDefault(require("../../../hooks/useTranslation"));
var WofWinModal = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, data = _a.data;
    var t = (0, useTranslation_1.default)("wof").t;
    // const ctaText = useMemo(() => {
    //   if (data.rewardType === Mini) {
    //     return "Câștigă mașina";
    //   }
    //   if (data.mustDeposit) {
    //     return "Depune acum";
    //   }
    //   return "Intră în joc";
    // }, [data]);
    // const { prizeName, message } = useMemo(() => {
    //   if (data.prizeType === WofPrizeTypes.Cashback) {
    //     return {
    //       prizeName: data.amount,
    //       message: data.message,
    //     };
    //   }
    //   return {
    //     prizeName: data.prizeName,
    //     message: data.message,
    //   };
    // }, [data]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: ref, className: "wof-container--body-win" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "wof-container--body-win--wrapper" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "wof-container--body-win--title" }, { children: t("congratulations") })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "wof-container--body-win--subtitle" }, { children: t("youWon") })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "wof-container--body-win--prize" }, { children: data.title })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "wof-container--body-win--extra" }, { children: t("giftIsInAccount") })), (0, jsx_runtime_1.jsx)("button", __assign({ className: "wof-container--body-button" }, { children: t("letsPlay") }))] })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "wof-container--body-win--footer" }, { children: t("continueToPlay") }))] })));
});
WofWinModal.displayName = "WofWinModal";
exports.default = WofWinModal;
